class photoUploadConfig {
  constructor() {
    this.maxSize = 1024*8
    this.sizeList = {
      large: { suffix: 'large', width: 1600, resize: 1 },
      middle: { suffix: 'middle', width: 800, resize: 1 },
      small: { suffix: 'small', width: 600, resize: 1 },
      tiny: { suffix: 'tiny', width: 200, resize: 1 },
    }

    this.avatar = {
      max_size: 1024,
      size: {
        middle: { suffix: 'middle', width: 420, height: 420 },
        small: { suffix: 'small', width: 240, height: 240 },
        tiny: { suffix: 'tiny', width: 60, height: 60 },
      },
    }

    this.computedSizeList = []
    this.setupComputedSizeList()
    return this.getConfig()
  }

  setupComputedSizeList() {
    for(const suffix in this.sizeList) {
      const config = this.sizeList[suffix]
      this.computedSizeList.push(config)
    }
  }

  getConfig() {
    return {
      default: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      html: {
        max_size: this.maxSize,
        size: [
          this.sizeList.middle,
        ],
      },
      page: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      banner: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      product: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      video: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      news: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      post: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      article: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      etc: {
        max_size: this.maxSize,
        size: this.computedSizeList,
      },
      user_avatar: this.avatar,
      member_avatar: this.avatar,
    }
  }
}

export default new photoUploadConfig()